import { render, staticRenderFns } from "./customerEventsTab.vue?vue&type=template&id=540d8cce&"
import script from "./customerEventsTab.vue?vue&type=script&lang=ts&"
export * from "./customerEventsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports